// The light site header's menu (SiteHeader), in one place so the desktop tabs and the mobile menu
// on the same page can never list different things.

export type SiteNavLink = {to: string; label: string};

export const featurePages: SiteNavLink[] = [
    {to: "/create-brackets/", label: "Create Tournament Brackets"},
    {to: "/sports-tournament-management-software/", label: "Sports Tournament Management"},
    {to: "/sports-league-management-software/", label: "Sports League Management"},
    {to: "/sports-analytics-software-for-clubs/", label: "Sports Analytics"},
    {to: "/live-scoring/", label: "Live Scoring"},
];

export const sportPages: SiteNavLink[] = [
    {to: "/padel-tournament-software/", label: "Padel"},
    {to: "/pickleball-tournament-software/", label: "Pickleball"},
    {to: "/tennis-tournament-software/", label: "Tennis"},
    {to: "/badminton-tournament-software/", label: "Badminton"},
    {to: "/squash-tournament-software/", label: "Squash"},
    {to: "/basketball-tournament-software/", label: "Basketball"},
    {to: "/football-tournament-software/", label: "Football"},
    {to: "/esports-tournament-software/", label: "Esports"},
    {to: "/volleyball-tournament-software/", label: "Volleyball"},
    {to: "/roundnet-tournament-software/", label: "Roundnet"},
];

/** The tabs after the Features dropdown, in header order. */
export const primaryLinks: SiteNavLink[] = [
    {to: "/pricing/", label: "Pricing"},
    {to: "/for-clubs/", label: "For Clubs"},
    {to: "/for-communities/", label: "For Communities"},
    {to: "/tournament-management-software/", label: "Resources"},
    {to: "/blog/", label: "Blog"},
    {to: "/contact/", label: "Contact"},
];
